import { InertiaLink, useForm, usePage } from '@inertiajs/inertia-react'
import route from 'ziggy-js'
import MenuButton from '../Header/MenuButton'
import OpeningWidget from '../Header/OpeningWidget'
import Img from '../Img'

export function MainCateringHeader({ wide, relative, dark }: { wide?: boolean, relative?: boolean, dark?: boolean }) {

    return (
        <>
            <header className={"z-40 left-0 right-0 w-full p-16px  border-b border-opacity-16 fixed flex justify-between " + (dark ? " bg-brown-dark text-white border-brown-inverted" : " bg-white text-brown-dark border-brown-dark")}>
                <InertiaLink href={route("catering")} className="flex">
                    {/* <Img className="mr-16px" src={dark ? "/assets/img/catering/cafe_inverted.svg" : "/assets/img/logo.svg"} /> */}
                    <Img className="mr-16px" src={"/assets/img/catering/catering_logo.svg"} />
                    {/*  <OpeningWidget dark={dark} /> */}
                </InertiaLink>
                <MenuButton noMobileShift={wide ? true : false} dark={dark} />
            </header>
            {relative &&
                <div className="h-60px md:h-75px w-full"></div>
            }

        </>
    )
}



